module.exports = __webpack_public_path__ + "img/call_silent.347b1cad.svg";